import { AtividadePontuacao, NotaPontuacao } from '@app/core/models/perfil-profissiografico/detalhar-pontuacao';
import { ConfirmationService, MessageService } from 'primeng/api';

import { Component, Input } from '@angular/core';
import { DetalharLaudoService } from '../services/detalhar-laudo.service';
import { PerfisEnum } from '@app/core/enums/perfis.enum';
import { UsuarioService } from '@sigepe/sigepe-template';

@Component({
	selector: 'sgp-detalhar-pontuacao',
	templateUrl: './detalhar-pontuacao.component.html',
	providers: [ConfirmationService, MessageService]
})
export class DetalharPontuacaoComponent {
	@Input() situacaoLaudo?: string;
	isPesquisador = false;

	constructor(
		protected detalharLaudoService: DetalharLaudoService,
		private confirmationService: ConfirmationService,
		private messageService: MessageService,
		private usuarioService: UsuarioService
	) {
		const perfisUsuario = this.usuarioService.getUsuario().perfis;
		this.isPesquisador = perfisUsuario?.includes(PerfisEnum.PESQUISADOR) ?? false;
	}

	desconsiderarMatch(nota: NotaPontuacao): void {
		this.confirmationService.confirm({
			header: 'Desconsiderar Match',
			message: 'Esta ação é irreversível e não poderá ser desfeita posteriormente. Confirmar a desconsideração da comparação?',
			accept: () => {
				this.detalharLaudoService.desconsiderarMatch(nota.idPontuacaoIntermediaria).subscribe({
					next: () => {
						if (this.detalharLaudoService.idCandidato) {
							this.detalharLaudoService.detalharPontuacao(this.detalharLaudoService.idCandidato);
						}
					},
					error: () => { }
				});
			}
		});
	}

	getTotalGraduacao(atividade: AtividadePontuacao): number {
		return this.somarPontuacaoPorCriterio(atividade, 'Graduação');
	}

	getTotalPos(atividade: AtividadePontuacao): number {
		return this.somarPontuacaoPorCriterio(atividade, 'Pós Graduação, Mestrado ou Doutorado');
	}

	getTotalCursos(atividade: AtividadePontuacao): number {
		return this.somarPontuacaoPorCriterio(atividade, 'Cursos, Treinamentos, Workshops');
	}

	getTotalExperiencia(atividade: AtividadePontuacao): number {
		return this.somarPontuacaoPorCriterio(atividade, 'Experiência');
	}

	getTotalInteresse(atividade: AtividadePontuacao): number {
		return this.somarPontuacaoPorCriterio(atividade, 'Interesse');
	}

	getPontuacaoFormacao(atividade: AtividadePontuacao): number {
		return atividade.totalPontuacaoFormacao;
	}

	calcularPontuacaoFinal(atividade: AtividadePontuacao): number {
		return atividade.totalPontuacaoGeral;
	}

	private somarPontuacaoPorCriterio(atividade: AtividadePontuacao, criterio: string): number {
		return atividade.notas
			.filter((n: NotaPontuacao) => n.nomeCriterio === criterio && n.pontuacaoConsiderada)
			.reduce((soma: number, n: NotaPontuacao) => soma + n.pontuacaoObtida, 0);
	}
}
